module.exports = __webpack_public_path__ + "static/media/www.porssiklubi.fi.60eb7504.png";